// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XjPS1","input":"styles_input__2NXgQ"};